import { CurrentUserConnections, OrgType } from '@cpd-app/core-module/models';

export const ORG_TYPES = {
  ACADEMIC: 'academic',
  EMPLOYER: 'employer',
  NON_PROFIT: 'nonprofit'
} satisfies Record<string, OrgType>;

/**
 * What the panel assumes before the server has told it anything.
 *
 * `autoShareEnabled` is false, matching the backend: `user-connection.service.ts`
 * inserts `auto_share_enabled` as `?? false` and reports
 * `autoShareEnabled: false` for a member with nothing stored. It used to be
 * true here, so the Auto-share toggle painted itself ON and then flipped OFF
 * when the real state arrived. A data-sharing control has to start where the
 * data actually is.
 */
export const DEFAULT_CONNECTION_STATE = {
  academic: [],
  employer: [],
  nonprofit: [],
  totalCount: 0,
  premiumPartnerIds: [],
  autoShareEnabled: false,
  hasOutdatedConnection: false,
  academicConnections: [],
  adultConfirmedAt: null
} satisfies CurrentUserConnections;

export const PREMIUM_PARTNER_TYPE = 'premium';

export const TERM_MONTH_MAP: Record<string, number[]> = {
  Spring: [0, 1, 2],
  Summer: [3, 4, 5],
  Fall: [6, 7, 8],
  Winter: [9, 10, 11]
};

export const E164_REGEX = /^\+?[1-9]\d{1,14}$/ satisfies RegExp;
